import React from 'react';

function EmptyState({ hasFilter, onClearFilter }) {
  return (
    <div className="empty-state">
      <svg
        className="empty-illustration"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        aria-hidden="true"
      >
        <rect x="20" y="28" width="80" height="64" rx="6" fill="var(--color-mist)" />
        <rect x="20" y="28" width="80" height="16" rx="6" fill="var(--color-fog)" />
        <rect x="30" y="54" width="40" height="4" rx="2" fill="var(--color-fog)" />
        <rect x="30" y="64" width="60" height="4" rx="2" fill="var(--color-fog)" />
        <rect x="30" y="74" width="30" height="4" rx="2" fill="var(--color-fog)" />
        <circle cx="92" cy="88" r="20" fill="var(--color-cloud)" stroke="var(--color-canopy)" strokeWidth="2" />
        {hasFilter ? (
          <path
            d="M86 82l12 12m0-12l-12 12"
            stroke="var(--color-canopy)"
            strokeWidth="2"
            strokeLinecap="round"
          />
        ) : (
          <path
            d="M86 88l4 4 8-8"
            stroke="var(--color-canopy)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </svg>
      <h3 className="empty-title">
        {hasFilter ? 'No matching terminations' : 'Queue is clear'}
      </h3>
      <p className="empty-description">
        {hasFilter
          ? 'Try adjusting your search or filters.'
          : 'No terminations are currently pending processing.'}
      </p>
      {hasFilter && (
        <button onClick={onClearFilter} className="empty-action">
          Clear filters
        </button>
      )}
    </div>
  );
}

export default EmptyState;
